module.exports = __webpack_public_path__ + "img/total_sales.4494cca0.svg";